export default __webpack_public_path__ + "static/photoGalleryModule_cloud_bottom-214d3a458648ae9caec1b66608a6f8ea.png";